var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"50vw","width":"100%"}},[_vm._v(" "+_vm._s(_vm.displayText)+" "),(_vm.text.length > 100)?_c('v-btn',{attrs:{"small":"","text":""},on:{"click":function($event){_vm.showAll = !_vm.showAll}}},[_vm._v(" "+_vm._s(_vm.showAll ? 'Show less' : 'Show more')+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }